export default __webpack_public_path__ + "static/spitz-fonts-aa93bc3df7d73088b93b29510ce45bcd.jpg";